export default "__VITE_ASSET__FR8Q20FX__"